@import '@/styles/variables/index.less';
@import '@/styles/mixins/effects.less';
@import '@/styles/mixins/animations.less';

@import '@/styles/mixins/index.less';
.button {
  border-radius: @radius-md;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
  border: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
  }
}

.content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.label {
  line-height: 1.25;
}

.fullWidth {
  width: 100%;
}

// Variants
.variant-primary {
  background-color: @accent;
  color: @primary-foreground;
  box-shadow: 0 10px 20px rgba(22, 22, 22, 0.08);

  .hover-supported({

    &:not(:disabled) {
      background-color: color-mix(in srgb, var(--color-accent) 90%, black);
  

    }

  });
}

.variant-secondary {
  background-color: color-mix(in srgb, var(--color-surface) 90%, white);
  color: @foreground;
  border-color: color-mix(in srgb, var(--color-border) 60%, transparent);

  .hover-supported({

    &:not(:disabled) {
      background-color: color-mix(in srgb, var(--color-surface) 85%, white);
  

    }

  });
}

.variant-ghost {
  background-color: transparent;
  color: @accent;
  border: none;

  .hover-supported({

    &:not(:disabled) {
      background-color: color-mix(in srgb, var(--color-foreground) 8%, transparent);
  

    }

  });
}

.variant-danger {
  background-color: @destructive;
  color: white;
  box-shadow: 0 10px 20px rgba(220, 38, 38, 0.15);

  .hover-supported({

    &:not(:disabled) {
      background-color: color-mix(in srgb, var(--color-error) 90%, black);
  

    }

  });
}

// Sizes
.size-sm {
  height: 2.25rem;
  padding: 0 12px;
  font-size: 12px;
}

.size-md {
  height: 2.75rem;
  padding: 0 16px;
  font-size: 14px;
}

.size-lg {
  height: 3.125rem;
  padding: 0 20px;
  font-size: 14px;
}

.size-icon {
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;

  .content {
    gap: 0;
  }
}

.loading {
  cursor: wait;
}

.spinner {
  .animate-spin();
  height: 16px;
  width: 16px;
}

.spinnerCircle {
  opacity: 0.25;
}

.spinnerPath {
  opacity: 0.75;
}
